import * as React from 'react';
import ForecastSearchBox from './ForecastFilter/ForecastSearchBox';
import LastForecastReceived from './ForecastFilter/LastForecastReceived';

const ForecastFilter = (props) => {
    return (
        <div className='container-fluid-plp'>
            <div className='bs5 row m-b-10'>
                <ForecastSearchBox />

                <LastForecastReceived />
            </div>
        </div>
    );
}

export default ForecastFilter;